import { axios, formAxios, path } from './config';
import qs from 'qs';
import config from 'config';
import { ONE, FIVE, TEN, productTypes, APP_NAME } from 'appConstants';
import { formattedHeaders } from 'components/Teams/helper.js';

export function getTeam({ customerId, teamId }) {
  const params = {
    customer_id: customerId,
    team_id: teamId,
  };

  return axios.get(path.GET_TEAM, { params });
}

export function getTeams({ customerId, page = ONE, itemsPerPage = FIVE, filter, sort }) {
  const params = {
    customer_id: customerId,
    filter: JSON.stringify(filter),
    items_per_page: itemsPerPage,
    page,
    sort,
  };

  return axios.get(`${path.TEAMS}${qs.stringify(params)}`);
}

export function getTeamsUsers({
  customerId,
  page = ONE,
  itemsPerPage = FIVE,
  filter,
  phone,
  teamFqdn,
  sort,
}) {
  const queryFilter = [{ fieldName: 'status', type: 'NotEquals', value: 'deleted' }];
  let formattedFilter = null;

  if (filter) {
    formattedFilter = JSON.stringify([...queryFilter, ...filter]);
  } else {
    formattedFilter = JSON.stringify(queryFilter);
  }

  const params = {
    customer_id: customerId,
    filter: formattedFilter,
    items_per_page: itemsPerPage,
    page,
    ...(phone && { phone }),
    team_fqdn: teamFqdn,
    sort,
  };

  return axios.get(path.MGR_USERS, { params });
}

export function createTeam({ customerId, teamName, parentTeamId }) {
  const params = {
    customer_id: customerId,
    team_name: teamName,
  };

  if (parentTeamId) {
    params.parent_team_id = parentTeamId;
  }

  return axios.post(`${path.TEAM}${qs.stringify(params)}`);
}

export function bulkEditTeamsUsers({ customerId, users, action }) {
  const params = {
    customer_id: customerId,
    bulk_users_update_type: action,
    team_id: users[0].teamId,
  };

  return axios.post(`${path.BULK_EDIT_TEAM_USERS}${qs.stringify(params)}`, users);
}

export function editTeamDetails({ customerId, teamName, teamId, teamOptOutMessage }) {
  const params = {
    customer_id: customerId,
    team_name: teamName,
    team_id: teamId,
    initial_opt_out_msg: teamOptOutMessage,
  };

  return axios.post(`${path.EDIT_TEAM}${qs.stringify(params)}`);
}

export function removeTeam({ customerId, teamId }) {
  const params = {
    customer_id: customerId,
    team_id: teamId,
  };

  return axios.delete(`${path.DELETE_TEAM}${qs.stringify(params)}`);
}

export function exportTeams({ customerId }) {
  const params = {
    customer_id: customerId,
  };

  return axios.get(`${path.DOWNLOAD_TEAMS}${qs.stringify(params)}`);
}

export function getBgEventTasks({ pageNumber = ONE, itemsPerPage = TEN, userName, teamId }) {
  return axios.get(path.BACKGROUND_EVENTS, {
    params: {
      items_per_page: itemsPerPage,
      page: pageNumber,
      filter: JSON.stringify([
        { fieldName: 'type', type: 'Equals', value: 'BULK_USERS_UPDATE' },
        { fieldName: 'userName', type: 'Equals', value: userName },
        { fieldName: 'status', type: 'Equals', value: 'Processing' },
        { fieldName: 'teamId', type: 'Equals', value: teamId },
      ]),
    },
  });
}

export function teamsFileUpload({ uploadHeaders, customerId, uid }) {
  const params = {
    account_id: customerId,
    uid,
  };

  const data = {
    uid,
    account_id: customerId,
    fields: JSON.stringify(formattedHeaders(uploadHeaders)),
    client_ver: config.clientVersion,
    app_name: APP_NAME,
    product: productTypes.TEXT_RECRUIT,
  };

  return formAxios.post(`${path.TEAMS_IMPORT}${qs.stringify(params)}`, qs.stringify(data));
}
